<section class="scan-page">
  <header class="scan-topbar">
    <button type="button" class="scan-close-button" (click)="close()" aria-label="ปิดหน้าสแกน">
      <i class="bi bi-arrow-left"></i>
    </button>
    <div class="scan-title-block">
      <span>สแกน QR Code</span>
      <strong>ยกกล้องให้ตรงกับ QR เพื่อเปิดรายการอัตโนมัติ</strong>
    </div>
  </header>

  <div class="scan-stage">
    <div class="scan-viewfinder">
      <video #scannerVideo playsinline autoplay muted></video>
      <div class="scan-frame" aria-hidden="true"></div>
      <div class="scan-shadow top"></div>
      <div class="scan-shadow right"></div>
      <div class="scan-shadow bottom"></div>
      <div class="scan-shadow left"></div>
      @if (navigating()) {
        <div class="scan-route-overlay">
          <div class="scan-route-status">
            <i class="bi bi-arrow-repeat"></i>
            <strong>{{ statusTitle }}</strong>
            <p>{{ statusDescription }}</p>
          </div>
        </div>
      }
    </div>

    <div class="scan-status-card">
      @if (scannerError()) {
        <div class="scan-status error">
          <i class="bi bi-exclamation-octagon"></i>
          <div>
            <strong>{{ scannerError() }}</strong>
            <p>ตรวจสอบสิทธิ์กล้อง หรือทดลองเปิดใหม่อีกครั้ง</p>
          </div>
        </div>
      } @else {
        <div class="scan-status">
          <i class="bi" [ngClass]="scanning() ? 'bi-qr-code-scan' : 'bi-camera-video'"></i>
          <div>
            <strong>{{ scanning() ? 'กำลังสแกน QR' : 'เตรียมเปิดกล้อง' }}</strong>
            <p>{{ detectedCode() || 'เมื่อพบ URL ใน QR ระบบจะเปิดหน้าเป้าหมายให้อัตโนมัติ' }}</p>
          </div>
        </div>
      }

      <div class="scan-actions">
        <button type="button" class="scan-secondary-button" (click)="close()" [disabled]="navigating()">
          กลับ
        </button>
        <button type="button" class="scan-primary-button" (click)="retry()" [disabled]="!canUseScanner || navigating()">
          {{ navigating() ? 'กำลังเปิดรายการ...' : 'เปิดกล้องใหม่' }}
        </button>
      </div>
    </div>
  </div>
</section>
